import { HelpTopic } from 'data/entities/entities';
import { AppRepository } from '../app-repository';

export class HelpTopicRepository extends AppRepository {
	

}
